export default () => ({
  selectedFilters: {
    channel: [],
    healthCommunitySpecialistSpeciality: [],
    type: [],
    physician: []
  },
  otherFilters: null // Set other type of filter comming from other pillars
})
